"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _utils = require("../utils");
const RotatingContainer = /*#__PURE__*/(0, _base.default)('div', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (0, _utils.filterProps)(['isRotated']),
  target: "e1fhen290"
} : {
  shouldForwardProp: (0, _utils.filterProps)(['isRotated']),
  target: "e1fhen290",
  label: "RotatingContainer"
})(_ref => {
  let {
    isRotated
  } = _ref;
  return {
    transition: 'transform 0.2s',
    transform: isRotated ? 'rotate(180deg)' : 'rotate(0)'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2hlbHBlcnMvUm90YXRpbmdDb250YWluZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkwQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvc3VibW9kdWxlcy9oZWxwZXJzL1JvdGF0aW5nQ29udGFpbmVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgZmlsdGVyUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmNvbnN0IFJvdGF0aW5nQ29udGFpbmVyID0gc3R5bGVkKCdkaXYnLCB7XG4gIHNob3VsZEZvcndhcmRQcm9wOiBmaWx0ZXJQcm9wcyhbJ2lzUm90YXRlZCddKVxufSk8e1xuICBpc1JvdGF0ZWQ6IGJvb2xlYW47XG59PigoeyBpc1JvdGF0ZWQgfSkgPT4gKHtcbiAgdHJhbnNpdGlvbjogJ3RyYW5zZm9ybSAwLjJzJyxcbiAgdHJhbnNmb3JtOiBpc1JvdGF0ZWQgPyAncm90YXRlKDE4MGRlZyknIDogJ3JvdGF0ZSgwKSdcbn0pKTtcblxuUm90YXRpbmdDb250YWluZXIuZGlzcGxheU5hbWUgPSAnUm90YXRpbmdDb250YWluZXInO1xuXG5leHBvcnQgZGVmYXVsdCBSb3RhdGluZ0NvbnRhaW5lcjtcbiJdfQ== */");
RotatingContainer.displayName = 'RotatingContainer';
var _default = exports.default = RotatingContainer;